import { render, staticRenderFns } from "./InstructionsCard.vue?vue&type=template&id=0d86acee&"
import script from "./InstructionsCard.vue?vue&type=script&lang=js&"
export * from "./InstructionsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports